'use client';
import classNames from 'classnames';
import './index.scss';
import { useCallback, useRef, useState } from 'react';
import { LazyObserverCallback, useLazyObserver } from './useLazyObserver';

export interface EcoImgProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc?: string;
    /**
     * 分辨率[1024, 768]
     */
    pad?: string;
    /**
     * 分辨率[1024, 0) 或 (768, 0)
     */
    h5?: string;
    /**
     * 介绍这是个什么图片
     */
    alt?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 高度
     */
    height?: number;
    /**
     * 懒加载
     */
    lazy?: boolean;
}

/**
 * 维护:谢保林
 *
 * 图片容器
 *
 * 为提升性能,使用 background 来展示,因此使用时必须给这个容器设置高度,宽度默认为100%
 *
 * 其中只展示图片中间部分,即 background-size: cover;
 */
export default function EcoImg({ className = '', alt = 'eco-IMG', pc, pad, h5, height = 0, lazy = true }: EcoImgProps) {
    const prefixCls = 'eco-img';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-has-pad`]: pad,
    });
    const boxRef = useRef<HTMLDivElement>(null);
    const [compStyle, setCompStyle] = useState({});
    const newStyles = {} as any;
    if (pc) newStyles['--eco-img-pc'] = `url('${pc}')`;
    if (pad) newStyles['--eco-img-pad'] = `url('${pad}')`;
    if (h5) newStyles['--eco-img-h5'] = `url('${h5}')`;
    useLazyObserver(boxRef, () => setCompStyle(newStyles), lazy);
    if (!pc) {
        return null;
    }
    return (
        <div className={compCls} style={lazy ? compStyle : newStyles} ref={boxRef}>
            {h5 && <figure className={`${prefixCls}-item ${prefixCls}-item-h5`} aria-label={alt}></figure>}
            {pad && <figure className={`${prefixCls}-item ${prefixCls}-item-pad`} aria-label={alt}></figure>}
            <figure className={`${prefixCls}-item ${prefixCls}-item-pc`} aria-label={alt}></figure>
        </div>
    );
}
